export default {"src":"/_next/static/media/escalade.2619aac7.svg","height":685,"width":685,"blurWidth":0,"blurHeight":0};